import { userInfoSync } from 'hub-http/userInfo';
import { useMemo } from 'react';
import { SCOPE_SUPER_ADMIN, SCOPE_MULTI_ACCOUNT_COPY_ASSETS_WRITE } from '../constants/scopes';
import { useHasCopyAssetConnectionAsSourceQuery } from '../../__generated__/chirp/com/hubspot/multi/account/configuration/manager/rpc/MultiAccountConnectionsChirpService.hooks';
export function useHasAssetCopierAccess() {
  const {
    user
  } = userInfoSync();
  const isSuperAdmin = useMemo(() => (user === null || user === void 0 ? void 0 : user.scopes.includes(SCOPE_SUPER_ADMIN)) || false, [user]);
  const hasCopyAssetsWriteScope = useMemo(() => (user === null || user === void 0 ? void 0 : user.scopes.includes(SCOPE_MULTI_ACCOUNT_COPY_ASSETS_WRITE)) || false, [user]);
  const {
    loading: hasCopyAssetConnectionAsSourceLoading,
    data: hasCopyAssetConnectionAsSourceData
  } = useHasCopyAssetConnectionAsSourceQuery();
  const hasAssetCopierAccess = useMemo(() => !hasCopyAssetConnectionAsSourceLoading && !!(hasCopyAssetConnectionAsSourceData !== null && hasCopyAssetConnectionAsSourceData !== void 0 && hasCopyAssetConnectionAsSourceData.hasCopyAssetConnectionAsSource) && (isSuperAdmin || hasCopyAssetsWriteScope), [isSuperAdmin, hasCopyAssetsWriteScope, hasCopyAssetConnectionAsSourceData, hasCopyAssetConnectionAsSourceLoading]);
  return {
    hasAssetCopierAccess,
    isSuperAdmin,
    hasCopyAssetsWriteScope,
    hasCopyAssetConnectionAsSource: hasCopyAssetConnectionAsSourceData === null || hasCopyAssetConnectionAsSourceData === void 0 ? void 0 : hasCopyAssetConnectionAsSourceData.hasCopyAssetConnectionAsSource,
    hasCopyAssetConnectionAsSourceLoading,
    hasContextualCopyingGate: true // TODO: Remove this once it has been removed from downstream dependencies
  };
}